import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@shared/ui/card";
import { PieChart } from "@shared/ui/chart";

interface TipsUtilityServiceChartProps {
  dashboardData?: {
    tipsUtilityServiceCounts: Array<{
      utilityService: string;
      count: number;
      percentage: number;
    }>;
  };
}

export const TipsUtilityServiceChart = ({ dashboardData }: TipsUtilityServiceChartProps) => {
  if (!dashboardData?.tipsUtilityServiceCounts) return null;

  const tipsUtilityServiceDistribution = dashboardData.tipsUtilityServiceCounts.map(
    (item) => ({
      service: item.utilityService,
      count: item.count
    })
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle className="card-heading-text">Tips by Utility Service</CardTitle>
        <CardDescription className="card-subheading-text">Tips distribution across utility services</CardDescription>
      </CardHeader>
      <CardContent>
        <PieChart
          data={tipsUtilityServiceDistribution}
          index="service"
          categories={["count"]}
          colors={["#6366F1", "#8B5CF6", "#D946EF", "#F97316", "#10B981"]}
          valueFormatter={(value) => `${value} tips`}
          className="h-[250px]"
        />
      </CardContent>
    </Card>
  );
};